import React, { FunctionComponent } from 'react';
import { ItemMenu } from './Menu';
import { MenuItemsProps } from './TreeMenu';
import { NavbarUlSmall } from './leftAppSidebarStyles';

const ContainerSmallMenu = (itemMenu: ItemMenu, goToMenu: (item: ItemMenu) => any) => {
    return null;
};

const SmallMenu: FunctionComponent<MenuItemsProps> = (props) => {
    return (
        <React.Fragment>
            <NavbarUlSmall>{ContainerSmallMenu(props.currentMenu, props.goToMenu)}</NavbarUlSmall>
        </React.Fragment>
    );
};

export default SmallMenu;
